import ProjectIndication from 'components/project/ProjectIndication';
import useInput from 'lib/hooks/useInput';
import { IToothShade, Tooth } from 'lib/types/projectTypes';
import { useDidUpdateEffect } from 'lib/utils';
import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { UtilActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';

interface ProjectIndicationContainerProps {
  projectInfo: object | any;
  isProjectCreator: boolean;
}
interface IndicationInfoToothShade {
  id: string;
  list: {
    seq: number;
    name: string;
  }[];
}

function ProjectIndicationContainer({
  projectInfo,
  isProjectCreator,
}: ProjectIndicationContainerProps) {
  const { indicationOptionOffline, indicationOptionOfflineSuccess, indicationInfo } =
    useShallowAppSelector(state => ({
      indicationOptionOffline: state.util.indicationOptionOffline.data,
      indicationOptionOfflineSuccess: state.util.indicationOptionOffline.success,
      indicationInfo: state.util.indicationInfo.data?.indicationInfo,
    }));

  const {
    teeth: teethValue,
    bridgeList: bridge,
    notation: numberingValue,
    shade,
    scanmode,
  } = projectInfo.indication;
  const isMultidie = projectInfo.isMultidie;

  const tooth = useInput({
    number: null,
  });
  const teeth = useInput([...teethValue]);
  const toothShade = useInput(shade);
  const scanMode = useInput(scanmode);
  const numbering = useInput(numberingValue);

  const toothShadeList = useMemo(
    () =>
      indicationInfo?.toothShadeList.reduce(
        (acc: IToothShade[], curr: IndicationInfoToothShade) => {
          let currArr = [{ group: curr.id }, ...curr.list];
          return acc.concat(currArr);
        },
        [],
      ),
    [indicationInfo],
  );
  const materialShadeList = useMemo(
    () =>
      [...indicationInfo?.materialShadeList].reduce(
        (acc: IToothShade[], curr: IndicationInfoToothShade) => {
          let currArr = [{ group: curr.id }, ...curr.list];
          return acc.concat(currArr);
        },
        [],
      ),
    [indicationInfo?.materialShadeList],
  );
  const teethIsExpanded = useMemo(() => {
    return teeth.value?.map((item: Tooth) => {
      return { number: item?.number, isExpanded: false };
    });
  }, [teeth]);
  const selectedTeethIsExpanded = useInput(teethIsExpanded);
  const [allIndicationOption, setAllIndicationOption] = useState(null);

  useEffect(() => {
    if (indicationOptionOfflineSuccess) {
      // const options = indicationOptionOffline?.list?.reduce((acc: any[], curr: any) => {
      //   const defaultOptions = makeAllOptionType(curr.default);
      //   const advancedOptions = makeAllOptionType(curr.advanced);

      //   defaultOptions.forEach(option => {
      //     if (!acc.some(accItem => accItem.key === option.key)) {
      //       acc.push(option);
      //     }
      //   });
      //   advancedOptions.forEach(option => {
      //     if (!acc.some(accItem => accItem.key === option.key)) {
      //       acc.push(option);
      //     }
      //   });

      //   return acc;
      // }, []);

      setAllIndicationOption(indicationOptionOffline);
    }
  }, [indicationOptionOfflineSuccess]);

  useEffect(() => {
    UtilActions.fetch_teeth_indication_option_offline_request();
  }, []);

  useEffect(() => {
    selectedTeethIsExpanded.setValue(teethIsExpanded);
  }, [teethIsExpanded]);

  useDidUpdateEffect(() => {
    handleSetTeethExpanded(tooth.value.number, true);
  }, [tooth.value]);

  const handleSelectedIndicationChange =
    (number: number) => (event: ChangeEvent<{}>, expanded: boolean) => {
      if (!selectedTeethIsExpanded) return;

      handleSetTeethExpanded(number, false);
    };

  const handleSetTeethExpanded = (number: number, isOnly?: boolean) => {
    selectedTeethIsExpanded.setValue(
      selectedTeethIsExpanded.value.map((item: any) => {
        if (item.number === number) {
          return { number: number, isExpanded: !item.isExpanded };
        } else {
          return !isOnly ? item : { number: item.number, isExpanded: false };
        }
      }),
    );
  };

  return (
    <ProjectIndication
      isMultidie={isMultidie}
      isViewer={true}
      isVaildTeethViewer={true}
      numbering={numbering}
      teeth={teeth}
      tooth={tooth}
      bridge={bridge}
      toothShade={toothShade}
      toothShadeList={toothShadeList}
      scanMode={scanMode}
      materialShadeList={materialShadeList}
      selectedTeethIsExpanded={selectedTeethIsExpanded}
      indicationInfo={indicationInfo}
      allIndicationOption={allIndicationOption}
      onSelectedIndicationChange={handleSelectedIndicationChange}
      isProjectCreator={isProjectCreator}
    />
  );
}

export default ProjectIndicationContainer;
